import { DataTable } from "primereact/datatable";
import {
  ActuallyResponseIdLotteryIdUserRequest,
  WithdrawalRequest,
} from "../../../../Transfer/models/transfer.model";
import { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Column } from "primereact/column";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";

interface Props {
  dataWithoutResponse: WithdrawalRequest[];
  setDataWithoutResponseRow: (data: WithdrawalRequest) => void;
  setDialogResponse: (data: boolean) => void;
  setDataWithResponseRow: (data: WithdrawalRequest) => void;
  setDialogWithResponse: (data: boolean) => void;
  actuallyResponseLottery: (
    data: ActuallyResponseIdLotteryIdUserRequest
  ) => void;
}

function TableWithdrawalRequest({
  dataWithoutResponse,
  setDataWithoutResponseRow,
  setDialogResponse,
  setDataWithResponseRow,
  setDialogWithResponse,
  actuallyResponseLottery,
}: Props): JSX.Element {
  const [globalFilter, setGlobalFilter] = useState<string | null>(null);

  const headerSearch = (
    <div className="flex justify-content-end w-full pb-2">
      <InputText
        style={{ width: "250px" }}
        type="text"
        placeholder="Buscar solicitud..."
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setGlobalFilter(e.target.value);
        }}
      />
    </div>
  );

  return (
    <div>
      <DataTable
        value={dataWithoutResponse}
        resizableColumns
        showGridlines
        tableStyle={{ minWidth: "50rem" }}
        emptyMessage="No hay resultados"
        globalFilter={globalFilter}
        header={headerSearch}
        paginator={dataWithoutResponse.length > 5}
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
      >
        <Column sortable field="idWithdrawalRequest" header="ID" style={{ width: "6%" }} />
        <Column sortable field="user.name" header="Nombre" />
        <Column sortable field="user.lastName" header="Apellido" />
        <Column sortable field="user.phone" header="Teléfono" />
        <Column sortable field="idLottery" header="Id Sorteo" style={{ width: "10%" }} />
        <Column
          sortable
          field="dateWithdrawalRequest"
          header="Fecha solicitud"
        />
        <Column
          field="responseWithdrawalRequest"
          header="Respuesta"
          body={(data: WithdrawalRequest) => {
            if (data.responseWithdrawalRequest === null) {
              return <Badge value="Pendiente" severity="warning" />;
            } else {
              return <Badge value="Resuelto" severity="success" />;
            }
          }}
        />
        <Column
          field="Acciones"
          header="Acciones"
          style={{ width: "12%" }}
          body={(data) => (
            <div className="flex justify-content-center gap-2">
              <Button
                tooltip="Responder"
                tooltipOptions={{ position: "top" }}
                icon="pi pi-pencil"
                className="p-button-rounded p-button-info"
                onClick={() => {
                  setDataWithoutResponseRow(data);
                  setDialogResponse(true);
                }}
              />
              {data.responseWithdrawalRequest !== null && (
                <Button
                  tooltip="Agregar respuesta"
                  tooltipOptions={{ position: "top" }}
                  icon="pi pi-plus"
                  className="p-button-rounded p-button-success"
                  onClick={() => {
                    const dataForResponse: ActuallyResponseIdLotteryIdUserRequest = {
                      idLottery: data.idLottery,
                      idUser: data.user.idUser,
                    };
                    actuallyResponseLottery(dataForResponse);
                    setDataWithResponseRow(data);
                    setDialogWithResponse(true);
                  }}
                />
              )}
            </div>
          )}
        />
      </DataTable>
    </div>
  );
}

export default TableWithdrawalRequest;